import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Avatar, Stack } from "@mui/material";
import Box from "@mui/material/Box/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography/Typography";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  selectNewProfile,
  selectNewProfileAvatar,
} from "../../../store/newProfile/selector";
import { homeStyle } from "../../../styles/container/home";
import { ProfileMenuProps } from "../../../types/modul-login";

export function ModulProfileMenu({
  profileMenu,
  setProfileMenu,
}: ProfileMenuProps) {
  const containerRef = useRef(null);
  const user = useSelector(selectNewProfile);
  const imageProfile = useSelector(selectNewProfileAvatar);
  const Navigate = useNavigate();

  return (
    <Box ref={containerRef} sx={homeStyle.modulProfileMenu}>
      <Paper
        elevation={4}
        sx={
          profileMenu
            ? homeStyle.modulProfileMenuContainer
            : { display: "none" }
        }
      >
        <Box
          sx={homeStyle.modulProfileMenuPaperBox1}
          onClick={() => setProfileMenu?.(!profileMenu)}
        >
          <Avatar src={imageProfile} sx={homeStyle.modulProfileMenuAvatar} />
          <Stack sx={homeStyle.modulProfileMenuAvatarContainer}>
            <Typography sx={homeStyle.modulProfileMenuAvatarName}>
              {user?.Name}
            </Typography>
            <Typography sx={homeStyle.modulProfileMenuAvatarID}>
              {user?.JobTitle}
            </Typography>
          </Stack>
        </Box>

        <Box
          sx={homeStyle.modulProfileMenuPaperBox3}
          onClick={() => Navigate("/logout")}
        >
          <ExitToAppIcon sx={homeStyle.modulProfileIcon2} />
          <Typography sx={homeStyle.modulProfileIconName}>
            <b>Log out</b>
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
